// Single source of truth for work/project data. Used by Home work section and menu.

import { MagicWandIcon, HandshakeIcon, PathIcon, SwatchesIcon } from '@phosphor-icons/react';
import XbertAiImg from '../images/hero/xbertai.png';
import NextIqImg from '../images/hero/nextiq.png';
import JournalImg from '../images/hero/journal.png';
import DesignSystemImg from '../images/hero/ds.png';

export const WORK_ITEMS = [
  {
    projectName: 'XBert AI',
    slug: '/xbertiq',
    path: '/xbertiq',
    label: 'XBert AI',
    imgSource: XbertAiImg,
    icon: MagicWandIcon,
    description: 'An AI assistant that handles customer conversations across voice, chat, and SMS for small businesses, including after hours, and hands off to people with full context.',
    featured: true,
    complete: true,
    protected: true,
  },
  {
    projectName: 'NextIQ',
    slug: '/next-iq',
    path: '/next-iq',
    label: 'NextIQ',
    imgSource: NextIqImg,
    icon: HandshakeIcon,
      description: 'A layered AI system that puts a conversational assistant, contextual inbox suggestions, and autopilot replies in one workspace, so teams move faster without losing control.',
    featured: true,
    complete: false,
    protected: true,
  },
  {
    projectName: 'Customer Journal',
    slug: '/journal',
    path: '/journal',
    label: 'Customer Journal',
    imgSource: JournalImg,
    icon: PathIcon,
      description: 'A milestone-first timeline that turns fragmented omni-channel conversations into one view of the customer relationship.',
      featured: false,
      complete: true,
    protected: true,
  },
  {
    projectName: 'Design system & UI modernization',
    slug: '/design-system',
    path: '/design-system',
    label: 'Design systems',
    imgSource: DesignSystemImg,
    icon: SwatchesIcon,
    description: 'A design system rebuilt with Cursor, Figma MCP, and AI agents, so teams share a faster, more consistent UI foundation.',
    featured: false,
    complete: true,
    protected: true,
  },
];

export const FEATURED_WORK = WORK_ITEMS.filter((w) => w.featured);
export const RESUME_URL = 'https://drive.google.com/file/d/1Dd5kBnVzHvljKcIavyRSCbNwZTTr1GYv/view?usp=sharing';
export const CONTACT_URL = 'https://www.linkedin.com/in/chinmayj93/';
